enum IProcurementMethodEnum {
  /**
   * 外卖
   * procurement_method = 2
   * Take Away
   */
  DINE_IN = 1,

  /**
   * 速递
   * procurement_method = 4
   */
  PICK_UP = 2,

  /**
   * 堂食
   * procurement_method = 1
   */
  DELIVERY = 3,

  /**
   * 堂食（自取）
   * procurement_method = 8
   */
  DINE_IN_UNASSIGNED = 4,

}


export default IProcurementMethodEnum;
